module.exports = __webpack_public_path__ + "static/media/ClubSeo - 2006.05.01.0c7635ec.swf";